// @ts-nocheck


import {
  monitoringVehicleStates,
  monitoringVehicleStatesEnum,
  monitoringVehicleStatusesEnum } from
'../../lib/enum';

export const getStatusIcon = (
vehicle,
isActive = false) =>
{
  const { state, status } = vehicle;
  let result = {};
  result.title = monitoringVehicleStates[state];
  if (isActive) {
    result.color = 'white';
  } else if (status === monitoringVehicleStatusesEnum.active) {
    result.color = '#27AE60';
  } else if (
  status === monitoringVehicleStatusesEnum.nosignal ||
  status === monitoringVehicleStatusesEnum.nonactive)
  {
    result.color = '#98A3AD';
  }
  if (state === monitoringVehicleStatesEnum.inmove) {
    result.type = 'moving';
  } else if (state === monitoringVehicleStatesEnum.stopped) {
    result.type = 'stopped';
  } else if (state === monitoringVehicleStatesEnum.parking) {
    result.type = 'parking';
    result.color = '#2770FF';
  }
  return result;
};

export const getUnixTime = (date) => {
  return Math.round(date.getTime() / 1000);
};

/**
 * Поиск тика относительно времени
 * @param ticks Массив тиков
 * @param curTime Время
 */
export const findTick = (ticks, curTime) => {
  const numberTicks = ticks.map(Number).sort((a, b) => a - b);
  const finded = numberTicks.find(
    (value, index) => curTime >= value && curTime < numberTicks[index + 1]
  );

  return finded === undefined &&
  numberTicks.length > 0 &&
  curTime >= numberTicks[numberTicks.length - 1] ?
  numberTicks[numberTicks.length - 1] :
  finded;
};
